import {
    Popconfirm,
    Table,
    Tooltip,
    notification, Image
} from "antd";
import {ColumnsType} from "antd/es/table";
import React, {useEffect, useState} from "react";
import {Button, Card, Col, Row} from "react-bootstrap";
import {Icon} from "ts-react-feather-icons";
import {ActionType} from "../../constants/actionType";
import {UserRole} from "../../constants/userRole";
import {useUser} from "../../hooks";
import User from "../../model/User";
import CustomPagination from "../CustomPagination";
import {
    deleteCharacterOutfitItem,
    generateCharacterOutfitItems,
    getCharacterOutfitItemDetail,
    getCharacterOutfitItems,
} from "../../helpers/api/character";
import OutfitItemDrawer from "./OutfitItemDrawer";

interface CharacterOutfitItemModel {
    key: React.Key;
    id: string;
    characterOutfitId: string;
    name: string;
    type: string;
    tags: string;
    imageUrl: string;
    createdBy: string;
    modifiedBy: string;
    createdAt: Date;
    modifiedAt: Date;
}

const CharacterOutfitItemTable = ({
                                      outfit
                                  }: any) => {

    const [pageSize, setPageSize] = useState<number>(10);
    const [pageIndex, setPageIndex] = useState<number>(1);
    const [totalRecord, setTotalRecord] = useState<number>(0);
    const [items, setItems] = useState<any[]>([]);
    const [itemDetail, setItemDetail] = useState<any>(null);
    const [actionType, setActionType] = useState<string>("");
    const [itemDrawerVisibility, setItemDrawerVisibility] = useState<boolean>(false);

    const currentLoggedInUser = useUser().user as User || null;
    const [api, contextHolder] = notification.useNotification();

    const [searchLoading, setSearchLoading] = useState<boolean>(false);


    const showError = (errorMessage: string) => {
        api.error({
            message: `Error notification`,
            description: <span className="text-danger">{errorMessage || 'There\'re some errors occured!'}</span>,
            placement: 'topRight'
        });
    }

    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

    const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
        setSelectedRowKeys(newSelectedRowKeys);
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };

    const columns: ColumnsType<CharacterOutfitItemModel> = [
        {
            title: "No.",
            dataIndex: "noNumber"
        },
        {
            title: "Name",
            dataIndex: "name",
            render: (text, record, index) => {
                return (
                    <span>
                        {record.name}
                    </span>
                )
            },
        },
        {
            title: "Preview",
            dataIndex: "imageUrl",
            render: (text, record, index) => {
                return (
                    <>
                        <Image
                            width={50}
                            src={record.imageUrl}
                        />
                    </>

                );
            },
        },
        {
            title: "Type",
            dataIndex: "type",

        },
        {
            title: "Created at",
            dataIndex: "createdAt",
            render: (text, record, index) => {
                return <span>{record?.createdAt ? new Date(record?.createdAt).toLocaleString() : ''}</span>
            }
        },
        {
            title: "Modified by",
            dataIndex: "modifiedBy",
        },
        {
            title: "Action",
            dataIndex: "action",
            render: (text, record, index) => {
                return (
                    (currentLoggedInUser?.roles?.includes(UserRole.SUPER_ADMIN) || currentLoggedInUser?.roles?.includes(UserRole.ADMIN)) && (
                        <>
                            <Tooltip title="Update">
                                <span role="button"
                                      onClick={() => triggerUpdate(record.id)}
                                      className="d-inline-block ms-1"
                                >
                                    <Icon name="edit-2" color="#0d6efd" size={16}/>
                                </span>
                            </Tooltip>
                            <Tooltip title={"Delete"}>
                                <Popconfirm
                                    title="Are you sure to delete this item?"
                                    onConfirm={() => triggerDeleteItem(record)}
                                    okText="Yes"
                                    cancelText="No"
                                >
                                    <span role="button"
                                          className="d-inline-block ms-1"
                                    >
                                        <Icon name="trash-2" color="#dc3545" size={16}/>
                                    </span>
                                </Popconfirm>
                            </Tooltip>
                        </>
                    )
                );
            },
        },
    ];

    useEffect(() => {
        if (!outfit) {
            return;
        }
        search();
    }, [pageIndex]);

    useEffect(() => {
        if (!outfit) {
            return;
        }
        if (pageIndex === 1) {
            search();
            return;
        }
        setPageIndex(1);
    }, [pageSize]);

    const search = async () => {
        setSearchLoading(true);
        const searchObj: any = {
            pageIndex: pageIndex - 1,
            pageSize,
        };
        try {
            const response = await getCharacterOutfitItems(outfit.characterId, outfit.id, searchObj);
            if (response.status === 200) {
                const data: any[] = [];
                response.data.data.forEach((item: any, index: number) => {
                    data.push({
                        ...item,
                        noNumber: (pageIndex - 1) * pageSize + index + 1,
                    });
                });
                setItems(data);
                setTotalRecord(response.data.totalRecord);
            }
        } catch (err) {
            console.error(err);
            api.error({
                message: `Error notification`,
                description: <span className="text-danger">{err as string || 'There\'re some errors occured!'}</span>,
                placement: 'topRight'
            });
        }
        setSearchLoading(false);
    }

    const triggerUpdate = async (itemId: string) => {
        try {
            if (!itemId || itemId?.trim()?.length === 0) {
                return;
            }
            const item = await getCharacterOutfitItemDetail(outfit.characterId, outfit.id, itemId);
            setItemDetail(item.data.data);
            setActionType(ActionType.UPDATE);
            setItemDrawerVisibility(true);
        } catch (err) {
            console.error(err);
            showError(err as string);
        }
    }

    const triggerDeleteItem = async (item: CharacterOutfitItemModel) => {
        try {
            if (!item || !item?.id) {
                return;
            }
            await deleteCharacterOutfitItem(outfit.characterId, outfit.id, item.id);
        } catch (err) {
            console.error(err);
            showError(err as string);
        }
        await search();
    }
    return (
        <>
            {contextHolder}

            <OutfitItemDrawer
                outfit={outfit}
                drawerVisibility={itemDrawerVisibility}
                setdDrawerVisibility={setItemDrawerVisibility}
                itemDetail={itemDetail}
                setItemDetail={setItemDetail}
                actionType={actionType}
                setActionType={setActionType}
                onSuccess={() => {
                    api.success({
                        message: `Successfull notification`,
                        description: (actionType === ActionType.CREATE ? "Create" : "Update") + ' item successfully!',
                        placement: 'topRight'
                    });
                    setItemDetail(null);
                    setActionType("");
                    search();
                }}
                onFailure={(errorMessage: string) => {
                    showError(errorMessage);
                }}
            />


            <Row>
                <Col>
                    <Card>
                        <Card.Body>
                            <Row>
                                <Col sm={6} className="mb-2">
                                    <span className="fw-bold lead text-success">OUTFITS</span>
                                </Col>
                                <Col sm={6} className="mb-2">
                                    <div className="text-sm-end">
                                        <Button variant="success" className="mb-1 py-1 me-1" onClick={() => {
                                            search();
                                        }}>
                                            <i className="mdi mdi-refresh me-1"></i> Refresh
                                        </Button>
                                        <Button variant="primary" className="mb-1 py-1 me-1" onClick={() => {
                                            setActionType(ActionType.CREATE);
                                            setItemDrawerVisibility(true);
                                        }}>
                                            <i className="mdi mdi-plus-circle me-1"></i> Create
                                        </Button>
                                        {
                                            (selectedRowKeys.length > 0 || items.length === 0) && (
                                                <Button variant="primary" className="mb-1 py-1 me-1" onClick={async () => {
                                                    if (selectedRowKeys.length > 0 || items.length === 0) {
                                                        const itemSelected = items.filter(item => selectedRowKeys.includes(item.noNumber));
                                                        const data = {
                                                            ids: itemSelected.map(item => item.id)
                                                        }

                                                        const itemsRes = await generateCharacterOutfitItems(outfit.characterId, outfit.id, data);
                                                        if (itemsRes?.status === 200) {
                                                            setSelectedRowKeys([]);
                                                            api.success({
                                                                message: `Successfull notification`,
                                                                description: "Generate items successfully!",
                                                                placement: 'topRight'
                                                            });
                                                            await search();
                                                            return;
                                                        }
                                                    } else {
                                                        api.error({
                                                            message: `Validation notification`,
                                                            description: "Please select at least 1 item to regen!",
                                                            placement: 'top'
                                                        });
                                                    }
                                                }}
                                                >
                                                    <i className="mdi mdi-plus-circle me-1"></i>{items.length > 0 ? 'Regen' : 'Generate'}
                                                </Button>
                                            )
                                        }
                                        {selectedRowKeys.length > 0 && (
                                            <Popconfirm
                                                title="Are you sure to delete this items?"
                                                onConfirm={async () => {
                                                    const itemSelected = items.filter(item => selectedRowKeys.includes(item.noNumber));
                                                    const itemIds = itemSelected.map(item => item.id);

                                                    for (let i = 0; i < itemIds.length; i++) {
                                                        await deleteCharacterOutfitItem(outfit.characterId, outfit.id, itemIds[i]);
                                                    }
                                                    setSelectedRowKeys([]);
                                                    api.success({
                                                        message: `Successfull notification`,
                                                        description: "Delete items successfully!",
                                                        placement: 'topRight'
                                                    });
                                                    await search();
                                                }}
                                                okText="Yes"
                                                cancelText="No"
                                            >
                                                <Button variant="danger" className="mb-1 py-1 me-1" onClick={() => {
                                                }}
                                                >
                                                    <i className="mdi mdi-delete me-1"></i>Delete
                                                </Button>
                                            </Popconfirm>
                                        )}

                                    </div>
                                </Col>
                            </Row>

                            <Table
                                rowSelection={rowSelection}
                                loading={searchLoading}
                                rowKey={"noNumber"}
                                className="table table-hover m-0 table-centered dt-responsive nowrap w-100"
                                dataSource={items}
                                columns={columns}
                                pagination={false}
                            />

                            {items?.length !== 0 && (
                                <CustomPagination
                                    pageIndex={pageIndex}
                                    pageSize={pageSize}
                                    totalItem={totalRecord}
                                    setPageSize={setPageSize}
                                    setPageIndex={setPageIndex}
                                />
                            )}
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </>
    )
}

export default CharacterOutfitItemTable;
